<template>
  <div id="tab-box">
    <div id="tab-header">
      <div :class="`nav-header${showBtn ? ' header-scroll' : ''}`">
        <div class="left btn"
             v-if="showBtn">
          <u-icon name="ChevronLeft"></u-icon>
        </div>
        <div class="right btn"
             v-if="showBtn">
          <u-icon name="ChevronRight"></u-icon>
        </div>
        <div class="nav-scroll">
          <div class="nav-box">
            <div v-for="(item, index) in tabList"
                 :key="item.key"
                 :class="`tab ${index === pickedIndex ? 'cur' : ''}`"
                 @click="handleTabChange(item, index)">
              {{item.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="tab-content"
         class="over-scroll">
        <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabList: {
      type: Array,
    },
  },
  data() {
    return {
      showBtn: false,
      pickedIndex: 0,
    }
  },

  created() {
    // this.pickedTitle = this.tabList[0].title
  },
  methods: {
    handleTabChange(row, index) {
      this.pickedIndex = index
      this.$emit('changeTab', row.key)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@src/styles/variables.scss';

#tab-box {
  // height: 210px;
  display: flex;
  flex-direction: column;
  color: $color-text;
  #tab-header {
    position: relative;
    // margin: 0 0 10px;
    .nav-header {
      overflow: hidden;
      position: relative;
      height: $line-height-small-l;
      line-height: $line-height-small-l;
      &.header-scroll {
        padding: 0 20px;
      }
      .nav-scroll {
        overflow: hidden;
        .nav-box {
          white-space: nowrap;
          position: relative;
          float: left;
          z-index: 2;
          cursor: pointer;
          .tab {
            padding: 0 10px;
            font-size: $font-size-small-l;
            display: inline-block;
            height: $line-height-small-l;
            // border-bottom: 2px solid transparent;
            &.cur {
              border-top: 2px solid $color-text-title;
              background-color: $color-bg-opacity;
            }
          }
        }
      }
      .btn {
        position: absolute;
        cursor: pointer;
        font-size: $font-size-small-s;
        &.left {
          left: 0;
        }
        &.right {
          right: 0;
        }
      }
    }
  }

  #tab-content {
    flex: 1;
    font-size: 1.6rem;
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    background-color: $color-bg-opacity;
  }
}
</style>


